export const defaultActionCreator = (type, param) => ({ type, payload: param });
